module.exports = __webpack_public_path__ + "img/gbp.cd34f235.svg";